/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_A2dInputs */

const en_mk_sol_startup_a2d = /** @type {(inputs: Mk_Sol_Startup_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts specs and user stories from existing issues, acceptance criteria included.`)
};

const id_mk_sol_startup_a2d = /** @type {(inputs: Mk_Sol_Startup_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyusun draf spesifikasi dan user story dari issue yang sudah ada, lengkap dengan kriteria penerimaan.`)
};

/**
* | output |
* | --- |
* | "Drafts specs and user stories from existing issues, acceptance criteria included." |
*
* @param {Mk_Sol_Startup_A2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_a2d = /** @type {((inputs?: Mk_Sol_Startup_A2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_A2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_a2d(inputs)
	return en_mk_sol_startup_a2d(inputs)
});